import React, { useState } from 'react';

export const NotificationSettings: React.FC = () => {
  const [config, setConfig] = useState({
    newRegistrationAlert: true,
    approvalNotification: true,
    rejectionNotification: true,
    dailyDigest: false,
    weeklyReport: true,
  });

  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      alert('Notification settings saved successfully!');
    } catch (error) {
      alert('Failed to save notification settings');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Notification Settings</h2>
        <p className="text-gray-600">Configure system-wide notification preferences</p>
      </div>

      <div className="space-y-4">
        {Object.entries({
          newRegistrationAlert: 'New Registration Alerts',
          approvalNotification: 'Approval Notifications',
          rejectionNotification: 'Rejection Notifications',
          dailyDigest: 'Daily Digest Email',
          weeklyReport: 'Weekly Summary Report',
        }).map(([key, label]) => (
          <div key={key} className="flex items-center justify-between p-4 border rounded-lg">
            <div>
              <div className="font-medium text-gray-900">{label}</div>
              <div className="text-sm text-gray-500">Send email notifications for this event</div>
            </div>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={config[key as keyof typeof config]}
                onChange={(e) => setConfig({ ...config, [key]: e.target.checked })}
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-gray-200 peer-focus:ring-4 peer-focus:ring-accent-300 rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-600"></div>
            </label>
          </div>
        ))}
      </div>

      <div className="flex justify-end pt-6 border-t">
        <button
          onClick={handleSave}
          disabled={saving}
          className="px-8 py-3 bg-accent-600 text-white rounded-lg hover:bg-accent-700 disabled:opacity-50 font-medium"
        >
          {saving ? 'Saving...' : 'Save Notification Settings'}
        </button>
      </div>
    </div>
  );
};
